const Arrowdownselect = () => {
  return (
    <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M5.18075 5.54034e-08L4.36351 6.38454e-08C2.11278 8.7095e-08 0.987422 9.87199e-08 0.744814 0.650606C0.502207 1.30121 1.35281 2.03804 3.05401 3.5117L3.46264 3.86566C4.08704 4.40654 4.39924 4.67698 4.77213 4.67698C5.14502 4.67698 5.45722 4.40654 6.08162 3.86567L6.08163 3.86566L6.49025 3.5117C8.19145 2.03804 9.04205 1.30121 8.79945 0.650606C8.55684 2.0529e-08 7.43148 3.21538e-08 5.18075 5.54034e-08Z" fill="#262F56"/>
    </svg>
  );
};

export default Arrowdownselect;
